/**
 * @file index.ts
 *
 * @fileoverview Get landing page training organizations query and helper methods.
 */
import gql from 'graphql-tag';

/**
 * Returns the appropriate variables for the training organizations query of landing pages.
 *
 * @param ctx
 *   The app context.
 * @returns
 *   Variables information for querying organizations.
 */
export const getTrainingOrganizationsVariables = (
  ctx: any,
  organizationsConfig,
) => {
  const trainingOrganizations =
    organizationsConfig.TRAINING_ORGANIZATIONS_SETTINGS;

  return {
    language: ctx.locale,
    range: {
      first: trainingOrganizations.RANGE.FIRST,
      last: trainingOrganizations.RANGE.LAST,
    },
  };
};

export const getTrainingOrganizations = (organizationsConfig) => {
  const imageStyle =
    organizationsConfig.TRAINING_ORGANIZATIONS_SETTINGS.IMAGE_STYLE;

  return gql`
    query trainingOrganizationProfiles(
      $language: String!
      $range: RangeInput!
    ) {
      organizationProfiles: trainingOrganizationProfiles(
        language: [$language]
        ranges: $range
      ) {
        result_count
        metadata: metatags {
          meta
          value
        }
        pages {
          ... on OrganizationProfile {
            id
            name
            url {
              path
            }
            logo(style: "${imageStyle}") {
              url
              alt
              title
            }
          }
        }
      }
    }
  `;
};
